(ns minorodata.components.sql-console.utils
  (:require ["lucide-react" :refer [Box Folder ListTree Table]]
            [clojure.string]))

(defn get-offset [node-type]
  (case node-type
    "catalog" ""
    "schema"  "pl-2"
    "table"   "pl-2"
    "column"  "pl-2"
    ""))

(defn get-header-class [node-type]
  (case node-type
    "catalog" "top-0 z-14 font-medium"
    "schema"  "top-6 z-13 font-normal"
    "table"   "top-12 z-12 font-normal"
    "column"  "font-normal"
    ""))

(defn generate-table-name [node]
  (str (:table-cat node) "." (:table-schem node) "." (:table-name node)))

(defn generate-select [{:keys [cols table limit]}]
  (str "SELECT\n    "
       cols
       "\nFROM\n  "
       table
       (if (some? limit)
         (str "\nLIMIT\n  " limit)
         "")
       ";"))

(defn generate-drop-table [{:keys [table]}]
  (str "DROP TABLE " table ";"))

(defn generate-columns [children]
  (clojure.string/join "\n  , " (map :column-name children)))

(defn node-type [node]
  (cond
    (:column-name node) "column"
    (:table-name node)  "table"
    (:table-schem node) "schema"
    (:table-cat node)   "catalog"
    :else               nil))

(defn type-icon [item-type]
  (case item-type
    "catalog" Folder
    "schema"  ListTree
    "table"   Table
    "column"  Box
    nil))

(defn node-object [node]
  (cond
    (:table-name node)  "columns"
    (:table-schem node) "tables"
    (:table-cat node)   "schemas"
    :else nil))

(defn node-title [node]
  (cond
    (:column-name node) (:column-name node)
    (:table-name node)  (:table-name node)
    (:table-schem node) (:table-schem node)
    (:table-cat node)   (:table-cat node)
    :else nil))

(defn fetch-params [node]
  (cond
    (:column-name node) nil
    (:table-name node)  {:object "columns"
                         :catalog (or (:table-catalog node) (:table-cat node))
                         :schema  (:table-schem node)
                         :table   (:table-name node)}
    (:table-schem node) {:object "tables"
                         :catalog (or (:table-catalog node) (:table-cat node))
                         :schema (:table-schem node)}
    (:table-cat node)   {:object "schemas"
                         :catalog (:table-cat node)}))
